import UserPrivacy from './index.vue'
export default UserPrivacy